export default __webpack_public_path__ + "static/media/bp_elevated.5926b874.svg";